<template>
  <div class="data-category-container">
    <router-link :to="{ name: to }">
      <div class="content-container">
        <img :src="image" />
        <div class="name">{{ name }}</div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    image: String,
    name: String,
    to: String,
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables';

div.data-category-container {
  margin: 1rem;
  width: 220px;
  min-width: 220px;
  max-width: 220px;
}

div.content-container {
  background-color: white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1.5rem 0 2rem;
}

img {
  min-height: 60px;
  max-height: 60px;
}

.name {
  margin-top: 1rem;
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.15;
  letter-spacing: normal;
  text-align: center;
  color: $navy;
}
</style>
